import React, { useState, useEffect } from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
const ConsentSelector = (props) => {
    const [selected, setSelected] = useState(props.selectedValue);
    useEffect(() => {
        console.log('inside consent selector: ', props.selectedValue);
        setSelected(props.selectedValue);
    }, [props.selectedValue]);
    const handleChange = (event, newSelection) => {
        console.log('on change: ', newSelection);
        if (newSelection !== null) {
            setSelected(newSelection);
            if (props.onSelectionChange) {
                props.onSelectionChange(newSelection); // Call parent callback function
            }
        }
    };
    return (React.createElement("div", { style: { display: 'flex', height: '30px' } },
        React.createElement(ToggleButtonGroup, { value: selected, exclusive: true, onChange: handleChange, "aria-label": "Consent Selection", sx: {
                borderRadius: '15px',
                overflow: 'hidden',
                boxShadow: 2,
                marginLeft: 'auto',
                marginRight: 'auto',
                width: '100%'
            } },
            React.createElement(ToggleButton, { value: "opt-in", sx: {
                    borderRadius: '15px 0 0 15px',
                    flex: 1,
                    backgroundColor: '#E0E0E0',
                    color: '#000000DE',
                    fontWeight: 'bold',
                    fontSize: '10px',
                    fontFamily: 'Barlow',
                    '&.Mui-selected': { backgroundColor: '#2C78EB', color: 'white' },
                } }, "OPT IN"),
            React.createElement(ToggleButton, { value: "no-consent", sx: {
                    flex: 1,
                    backgroundColor: '#E0E0E0',
                    color: '#000000DE',
                    fontWeight: 'bold',
                    fontSize: '10px',
                    fontFamily: 'Barlow',
                    '&.Mui-selected': { backgroundColor: '#2C78EB', color: 'white' },
                } }, "NO CONSENT"),
            React.createElement(ToggleButton, { value: "opt-out", sx: {
                    borderRadius: '0 15px 15px 0',
                    flex: 1,
                    backgroundColor: '#E0E0E0',
                    color: '#000000DE',
                    fontWeight: 'bold',
                    fontSize: '10px',
                    fontFamily: 'Barlow',
                    '&.Mui-selected': { backgroundColor: '#2C78EB', color: 'white' },
                } }, "OPT OUT"))));
};
export default ConsentSelector;
